import { render, staticRenderFns } from "./BlackSpecialPrize.vue?vue&type=template&id=7bc65fa4&scoped=true&"
import script from "./BlackSpecialPrize.vue?vue&type=script&lang=js&"
export * from "./BlackSpecialPrize.vue?vue&type=script&lang=js&"
import style0 from "./BlackSpecialPrize.vue?vue&type=style&index=0&id=7bc65fa4&prod&lang=less&scoped=true&"
import style1 from "./BlackSpecialPrize.vue?vue&type=style&index=1&id=7bc65fa4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc65fa4",
  null
  
)

export default component.exports